<template src="./VehicleUserMap.html"></template>
<script>
import { orderBy } from "@progress/kendo-data-query";
import EditCell from "@/components/EditCell";
import { createNamespacedHelpers } from "vuex";
const { mapState, mapActions, mapGetters } = createNamespacedHelpers("vehicleUserMap");
// import { MESSAGES } from "@/utils/constants";
// import { notify, notifyApiError } from "@/utils/notification-helper";
import DialogBox from "@/components/DialogBox";
import ViewDropdown from "@/components/ViewDropdown";
import UserAssignToVehicleDialog from "./UserAssignToVehicleDialog";
// import moment from "moment-timezone";
// import router from '@/router/index';

export default {
  components: {
    DialogBox,
    ViewDropdown,
    UserAssignToVehicleDialog,
  },
  data: function () {
    return {
      gridHeight: window.innerHeight - 150,
      // addoredit: false,
      gridData: [],
      skip: 0,
      take: 25,
      pageSize: 25,
      pageable: {
        previousNext: true,
        pageSizes: [5, 10, 25, 100, 500],
        pageSize: 10,
      },
      defaultVal: { name: "All", id: "All" },
      searchText: "",
      add: true,
      sort: [{ field: "vehicleRtoNum", dir: "asc" }],
      viewColumns: [],
      columns: [
        {
          hidden: false,
          field: "vehicleRTONumber",
          title: "RTO NUMBER",
          width: "250px",
          checked: true,
          defaultSelected: true,
        },
        {
          hidden: false,
          field: "users",
          title: "USERS",
          width: "250px",
          checked: true,
          cell: this.cellFunction,
          defaultSelected: true,
        },

        {
          hidden: false,
          cell: EditCell,
          title: "ACTIONS",
          width: "100px",
          locked: true,
          ignoreCheckbox: true,
        },
      ],
      dataItems: [],
      allowVendor: false,
      //  defaultVal: { name: 'All', id: 'all'},
    };
  },
  props: {
    selectedVehicleColumns: Array,
  },
  methods: {
    ...mapActions([""]),
    cellFunction: function (h, tdElement, props) {
      const field = props.field;
      const val = props.dataItem[field];
      const result = val.length ? val.map(v => v.userName).join(',') : '';
      return h("td", {}, result);
    },
    openWindow: function () {
      this.$router.push({ name: "vehicle-speed-limit-add", params: { } });
      // this.$router.push("/vehicle-management/add");
    },
    sortChangeHandler: function (e) {
      this.sort = e.sort;
    },

    pageChangeHandler: function (event) {
      this.skip = event.page.skip;
      this.take = event.page.take;
    },
    showAdd: function () {
      this.add = true;
    },
    remove: function (item) {
      this.dataItems = item;
      this.$refs.form.openWindow();
    },
    OkMethod() { // used in delete
    },
    edit: function (item) {
      this.$refs.addUsersToVehicle.open(item);
    },
    async getDataOnload() {
    },
    columnChange(e) {
      if (e.item.checked) {
        e.item.hidden = false;
      } else {
        e.item.hidden = true;
      }
      this.$store.commit("vehicleUserMap/setColumns", [
        ...this.columns,
      ]);
      localStorage.setItem(
        "vehicleManagementColumns",
        JSON.stringify(this.viewColumns)
      );
    },
    addUsersToVehicle (obj) {
      const users = obj.users.map((user) => ({ userId: user.id, userName: user.name}));
      this.$store.dispatch('vehicleUserMap/updateVehicleUserMap', { users, vehicleInfo: obj.vehicleInfo});
    },
    mapUserColumn(){
       return this.columns;
    }
  },
  computed: {
    ...mapState({
      vehicleData: (state) => state.vehicleData,
    }),
    ...mapGetters([
      "getUsers",
      "getVehicleUserMap"
    ]),
    total() {
      return this.$store.getters['vehicleUserMap/getVehicleUserMap'].length;
    },
    filter() {
      return {
        logic: "or",
        filters: [
          {
            field: "highSpeed",
            operator: "contains",
            value: this.searchText,
          },
          {
            field: "safeSpeed ",
            operator: "contains",
            value: this.searchText,
          },
          { field: "model ", operator: "contains", value: this.searchText },
        ],
      };
    },
    items: {
      get: function () {
        const text = this.searchText.toLowerCase();
        return orderBy(
          this.$store.getters['getVehicleUserMap'].filter((vum) => (
            vum.vehicleRTONumber + ""
            + vum.users.map((u) => u.userName).join(" ") 
          ).toLowerCase().includes(text)).slice(this.skip, this.take + this.skip),
          this.sort
        );
      },
    },
  },
  mounted() {
    this.getDataOnload();

    const eListColumns = JSON.parse(
      localStorage.getItem("vehicleManagementColumns")
    );
    if (!eListColumns) {
      this.viewColumns = [...this.columns];
      this.$store.commit("vehicle/setSelectedVehicleColumns", [
        ...this.columns,
      ]);
    } else {
      let items = [];
      this.columns.map((col, i) => {
        const obj = eListColumns.find((c) => c.field === col.field);
        // Ignoring last column
        if (i < this.columns.length - 1)
          if (obj) {
            items.push({
              ...col,
              hidden: obj.hidden,
              checked: obj.checked,
              defaultSelected: obj.defaultSelected,
              ignoreCheckbox: obj.ignoreCheckbox,
            });
          } else {
            items.push({ ...col });
          }
      });

      // adding ignored last column
      items.push(this.columns[this.columns.length - 1]);
      this.viewColumns = items;
      this.columns = items;
      this.$store.commit("vehicle/setSelectedVehicleColumns", items);
    }
  },
  created: function () {
    this.unsubscribe = this.$store.subscribe(async (mutation) => {
      if (mutation.type == "setInitialData") {
        this.getDataOnload();
      }
    });
  },
  beforeDestroy() {
    this.unsubscribe();
  },
  beforeMount() {},
};
</script>

<style lang="scss" scoped>
  .search_mobile{width: 15% !important; border-radius: 5px;}
@media only screen and (max-width: 768px) {
  .search_mobile{width: 40% !important;}
}
</style>
